import { render, staticRenderFns } from "./DiscussionCommentUpdate.vue?vue&type=template&id=449b7094&"
import script from "./DiscussionCommentUpdate.vue?vue&type=script&lang=js&"
export * from "./DiscussionCommentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports